import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link, useParams } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"
import DatePicker from "react-datepicker";
import moment from "moment";


const GETDATABYID = "api/suvichar"
const EDITDATA = 'api/suvichar/update'
function EditSuvichar() {

    document.title = "Edit Suvichar - Jain Sadhana"
    const { id } = useParams()
    const [editabledata, Setalleditabledata] = useState([]);
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();
    const [showDate, setShowdate] = useState(false)

    const showSchedule = () => {
        setShowdate(!showDate)
        if (showDate === true) {
            Setalleditabledata({ ...editabledata, status: "published" })
        }
        else {
            Setalleditabledata({ ...editabledata, status: "scheduled" })
        }
    };

    useEffect(() => {
        const getdatabyid = async () => {

            try {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                Setalleditabledata(response?.data?.suvichar)
                if (response?.data?.suvichar?.status === "scheduled") {
                    setShowdate(true)
                }
            } catch (error) {
                console.log(error?.response?.data?.message)
            }
        }
        getdatabyid();
    }, [])


    const HandleEdit = async (event) => {
        Setloading(true)
        event.preventDefault();
        const formdata = new FormData()
        formdata.append("englishtitle", editabledata?.englishtitle)
        formdata.append("hindititle", editabledata?.hindititle)
        formdata.append("content", editabledata?.content)
        formdata.append("image", editabledata?.image)
        formdata.append("status", editabledata?.status)
        formdata.append("scheduledate", moment(editabledata?.scheduledate).format("YYYY-MM-DD"))
        try {
            const editdata = await axios.patch(`${EDITDATA}/${id}`,formdata)

            if (editdata.status === 200) {
                navigate('/menu/suvicharlist')
                toast.success('Successfully Updated')
                Setloading(false)
            }
        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }
    }





    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" suvichar="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black'  >Edit Suvichar</p>
                                    <Link to="/menu/suvicharlist" className='text-black btn button-yellow  back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All Suvichar</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleEdit}>
                                        <div className="row employ-form-list">
                                        <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <label className='label-style text-center'> English Title</label>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata?.englishtitle} onChange={(event) => Setalleditabledata({ ...editabledata, englishtitle: event.target.value })}className="form-control  bg-gray border border-0" id="englishtitle" name='englishtitle' placeholder="Suvichar English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <label className='label-style text-center'> Hindi Title</label>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata?.hindititle} onChange={(event) => Setalleditabledata({ ...editabledata, hindititle: event.target.value })} className="form-control  bg-gray border border-0" id="hindititle" name='hindititle' placeholder="Suvichar Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <label className='label-style'> Content</label>
                                                        <div className="mb-3">
                                                            <textarea value={editabledata?.content} onChange={(event) => Setalleditabledata({ ...editabledata, content: event.target.value })} style={{ height: "150px" }}  className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Suvichar Content" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                    <label className='label-style'> Upload Image (if uploaded ,ignore)</label>
                                                        <div className=" mb-3">
                                                            <input name="image" onChange={(event) => Setalleditabledata({ ...editabledata, image: event.target.files[0] })} type="file" className="form-control " id="upload-file" 
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="align-items-center gap-2 mb-2 ">
                                                    <input type='checkbox' onClick={showSchedule} id='checkbox' checked={editabledata?.status === "scheduled"} />
                                                    <label className="label-style" htmlFor='checkbox'>Click on the Checkbox to Schedule</label>
                                                    {
                                                        showDate === true ? <div>
                                                            <label className="label-style d-block ms-4">Enter Schedule Date</label>
                                                            <DatePicker value={moment(editabledata?.scheduledate).format("YYYY-MM-DD")} selected={editabledata?.scheduledate ? moment(editabledata.scheduledate, 'YYYY-MM-DD').toDate() : null} minDate={new Date()} onChange={(date) => Setalleditabledata({ ...editabledata, scheduledate: date })} className="width50 form-control ms-4 border border-2 border-dark" />
                                                        </div> : ""
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                        {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/suvicharlist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditSuvichar